export default {
    methods: {
        toastAndReload(message, id = null) {
            this.loading = false;
            this.errors = {};
            this.$toastr.s('', message);
            if (id) this.$hub.$emit(`reload-${id}`)
        },
        toastException(data) {
            this.loading = false;
            this.$toastr.e('', data.message);
        },
        generateModalTitle(subject) {
            return this.$fieldTitle(this.selectedUrl ? 'edit' : 'add', subject, true);
        },
        scrollToTop(afterRender = true) {
            const handler = () => window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });

            if (afterRender) {
                setTimeout(() => handler())
            } else {
                handler();
            }
        },
        isImage(url) {
            const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
            const extension = url.toLowerCase().substring(url.lastIndexOf('.'));
            return imageExtensions.includes(extension);
        },
        getFileExtension(url) {
            return url.toLowerCase().substring(url.lastIndexOf('.'));
        },
        getFileName(url) {
            return url.split('/').reverse()[0];
        },
        viewFile(url) {
            window.open(url, '_blank');
        },
        // for multi file upload handler
        deleteFile(index) {
            this.deleted_files.push(this.current_files[index]);
            this.current_files.splice(index, 1);
        },
        redirectTo(path) {
            window.location.assign(path);
        }
    }
}
